import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import localize from 'helpers/translator/localize'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Confirm from 'views/confirm/confirm'
import oeqActions from 'redux/actions/oeqActions'

const AudioRecorderDeleteConfirm = props => (
	<Confirm
		alertMessage={localize('audio_recorder_delete_confirm_text')}
		btOne={localize('audio_recorder_delete_confirm_cancel')}
		btTwo={localize('audio_recorder_delete_confirm_confirm')}
		actionOne={props.actions.cancel}
		actionTwo={props.actions.delete}
		actionButtonType={1}
		closeAction={props.actions.cancel}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		delete: oeqActions.confirmAudioRecorderDelete,
		cancel: oeqActions.cancelAudioRecorderDelete,
	}, dispatch)
}

AudioRecorderDeleteConfirm.propTypes = {
	actions: PropTypes.shape({
		delete: PropTypes.func.isRequired,
		cancel: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(AudioRecorderDeleteConfirm)

export { AudioRecorderDeleteConfirm }
